import allIcon from '../../../assets/images/marketplace/categories/all.webp';
import beautyIcon from '../../../assets/images/marketplace/categories/beauty.webp';
import skincareIcon from '../../../assets/images/marketplace/categories/skincare.webp';
import fashionIcon from '../../../assets/images/marketplace/categories/fashion.webp';
import streetwearIcon from '../../../assets/images/marketplace/categories/streetwear.webp';
import sneakersIcon from '../../../assets/images/marketplace/categories/sneakers.webp';
import jewelryIcon from '../../../assets/images/marketplace/categories/jewelry.webp';
import foodBeverageIcon from '../../../assets/images/marketplace/categories/food-beverage.webp';
import homeIcon from '../../../assets/images/marketplace/categories/home.webp';
import electronicsIcon from '../../../assets/images/marketplace/categories/electronics.webp';
import toysIcon from '../../../assets/images/marketplace/categories/toys.webp';
import gamingIcon from '../../../assets/images/marketplace/categories/gaming.webp';
import collectiblesIcon from '../../../assets/images/marketplace/categories/collectibles.webp';
import sportsOutdoorsIcon from '../../../assets/images/marketplace/categories/sports-outdoors.webp';
import babyKidsIcon from '../../../assets/images/marketplace/categories/baby-kids.webp';
import petSuppliesIcon from '../../../assets/images/marketplace/categories/pet-supplies.webp';
import automotiveIcon from '../../../assets/images/marketplace/categories/automotive.webp';
import healthWellnessIcon from '../../../assets/images/marketplace/categories/health-wellness.webp';
import entertainmentIcon from '../../../assets/images/marketplace/categories/entertainment.webp';
import travelIcon from '../../../assets/images/marketplace/categories/travel.webp';
import lifestyleIcon from '../../../assets/images/marketplace/categories/lifestyle.webp';
import {
  canonicalizeCategoryLabel,
  getCategoryRailDisplayLabel as getCanonicalRailLabel,
} from '../../../constants/marketplaceCategories';

const ALL_VALUE = 'All';

const CATEGORY_ICON_SRC = {
  [ALL_VALUE]: allIcon,
  Beauty: beautyIcon,
  Skincare: skincareIcon,
  Fashion: fashionIcon,
  Streetwear: streetwearIcon,
  Sneakers: sneakersIcon,
  Jewelry: jewelryIcon,
  'Food & beverage': foodBeverageIcon,
  Home: homeIcon,
  Electronics: electronicsIcon,
  Toys: toysIcon,
  Gaming: gamingIcon,
  Collectibles: collectiblesIcon,
  'Sports & outdoors': sportsOutdoorsIcon,
  'Baby & kids': babyKidsIcon,
  'Pet supplies': petSuppliesIcon,
  Automotive: automotiveIcon,
  'Health & wellness': healthWellnessIcon,
  Entertainment: entertainmentIcon,
  Travel: travelIcon,
  Lifestyle: lifestyleIcon,
  // Legacy stored / URL labels until remap caches clear
  Hairstyling: beautyIcon,
  Babycare: babyKidsIcon,
  Outdoors: sportsOutdoorsIcon,
  "Women's clothing": fashionIcon,
  "Men's clothing": fashionIcon,
  Makeup: beautyIcon,
  Fitness: healthWellnessIcon,
  Food: foodBeverageIcon,
  'Luxury Fashion': fashionIcon,
  Parenting: babyKidsIcon,
  Wellness: healthWellnessIcon,
  Music: entertainmentIcon,
  Photography: lifestyleIcon,
};

function getCategoryIconSrc(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return allIcon;
  if (CATEGORY_ICON_SRC[trimmed]) return CATEGORY_ICON_SRC[trimmed];
  const canonical = canonicalizeCategoryLabel(trimmed, trimmed);
  return CATEGORY_ICON_SRC[canonical] || allIcon;
}

function getKnownCategoryIconSrc(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return null;
  if (CATEGORY_ICON_SRC[trimmed] && trimmed !== ALL_VALUE) {
    return CATEGORY_ICON_SRC[trimmed];
  }
  const canonical = canonicalizeCategoryLabel(trimmed, trimmed);
  if (canonical && CATEGORY_ICON_SRC[canonical] && canonical !== ALL_VALUE) {
    return CATEGORY_ICON_SRC[canonical];
  }
  return null;
}

function getCategoryRailDisplayLabel(name) {
  return getCanonicalRailLabel(name);
}

export {
  ALL_VALUE,
  CATEGORY_ICON_SRC,
  getCategoryIconSrc,
  getKnownCategoryIconSrc,
  getCategoryRailDisplayLabel,
};
